export default {
    clientSettings: [],
    sameEmail: false,
    emailChanged: false,
    emailErrors: {},
    deletionReasons: [],
    accountDeleteError: '',
    showSuccessMessage: false
};